//Components
import IosContact from 'react-ionicons/lib/IosContact'
import LazyLoadModule from '../../helpers/LazyLoadModule'
import IosArrowDropleft from 'react-ionicons/lib/IosArrowDropleft'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

//Styling
import '../dashboard.scss'
import colours from '../utilities/colours.scss'

//Functions and Data
import React from 'react'
import content from '../utilities/content.js'

function Nav({ setOpen, isOpen, admin, showText, history, logout }) {
  const { role } = JSON.parse(window.localStorage.getItem('userData'))

  const sectionView = (content, isOpen, i) => {
    return (
      <div className="section" key={i}>
        <div className="title">{content.name}</div>
        {content.rows
          .filter(
            item =>
              role === 'admin' ||
              (
                item.name !== 'Staff' && 
                item.name !== 'ChangeLogs' && 
                item.name !== 'Inventory' && 
                item.name !== 'Calendar Date Ranges' &&
                item.name !== 'Insights'
              )
          )
          .map((item, i) => {
            return rowView(item, isOpen, colours.fontColour1, i)
          })}
      </div>
    )
  }

  const rowView = (content, showText, colour, i) => {
    const iconAndLabel = (
      <>
        <LazyLoadModule
          resolve={() => import(`react-ionicons/lib/${content.icon}`)}
          style={{ color: colour }}
          fontSize="18px"
        />
        <div className={'text' + (showText ? '' : ' textClosed')}>
          {content.name}
        </div>
      </>
    )

    if (content.action === 'logout') {
      return (
        <div className="row" key={i} onClick={logout}>
          {iconAndLabel}
        </div>
      )
    }

    return (
      <Link
        className="row"
        key={i}
        to={content.redirect ? content.redirect : history.location.pathname}>
        {iconAndLabel}
      </Link>
    )
  }

  return (
    <div className={'navigation' + (isOpen ? '' : ' navClosed')}>
      <div className="navDummy"></div>
      <div className="navTop">
        <div className="avatarBackground"></div>
        <IosContact fontSize={isOpen ? '100px' : '35px'} className="avatar" />
        <div className="adminName">{showText ? admin.email : ''}</div>
      </div>
      {content.map((item, i) => {
        return sectionView(item, showText, i)
      })}
      <div className="toggle" onClick={() => setOpen(!isOpen)}>
        <IosArrowDropleft fontSize="20px" className="toggleIcon" />
      </div>
    </div>
  )
}

export default withRouter(Nav)
